import React from 'react';
import {OrbitComponent} from '../../base-components/orbit-component/orbit-component';
import {NEW_LIVE_CASINO_ARENA_NAME} from '../../../services/arenas/arena-consts';
import {MiniOrbitCasinoArenaComponent} from './casino-arena/mini-orbit-casino-arena.component';
import {MiniOrbitNewLiveCasinoArenaComponent} from "./new-live-casino-arena/mini-orbit-new-live-casino-arena.component";
import {observer} from 'mobx-react';

export interface MiniOrbitArenaHostComponentProps {
    arenaName: string;
}

export const MiniOrbitArenaHostComponent = observer(
    class MiniOrbitArenaHostComponent extends OrbitComponent<MiniOrbitArenaHostComponentProps> {
        render() {
            let arenaConfig = this.services.configuration.data.arenas[this.props.arenaName];
            if(!arenaConfig) {
                return null;
            }
            switch (this.props.arenaName) {
                case NEW_LIVE_CASINO_ARENA_NAME:
                    return (<MiniOrbitNewLiveCasinoArenaComponent configs={arenaConfig} arenaName={this.props.arenaName}/>);
                default:
                    return (<MiniOrbitCasinoArenaComponent arenaName={this.props.arenaName}/>);
                }
        }
    }
);